import {
  construirEmpleadoParaHistorialLaboral,
  extraerFechaYMD,
  obtenerPeriodoLaboralEnRango,
} from './fechaImportacion';

/**
 * Fecha de ingreso laboral efectiva en el rango de la planilla (solo referencia en UI).
 * No sustituye al historial que usa el motor de cálculo.
 */
export function resolverFechaIngresoReferencia(empleado, fechaInicioPlanilla, fechaFinPlanilla) {
  const empleadoLaboral = construirEmpleadoParaHistorialLaboral(empleado);
  const periodo = fechaInicioPlanilla && fechaFinPlanilla
    ? obtenerPeriodoLaboralEnRango(
        empleadoLaboral,
        fechaInicioPlanilla,
        fechaFinPlanilla
      )
    : null;
  return periodo?.fecha_ingreso ?? null;
}

/**
 * Fecha de cese del periodo que solapa con la planilla, solo si el cese cae dentro del rango de la planilla (referencia UI).
 */
export function resolverFechaCeseReferencia(empleado, fechaInicioPlanilla, fechaFinPlanilla) {
  const empleadoLaboral = construirEmpleadoParaHistorialLaboral(empleado);
  if (!fechaInicioPlanilla || !fechaFinPlanilla) return null;
  const periodo = obtenerPeriodoLaboralEnRango(
    empleadoLaboral,
    fechaInicioPlanilla,
    fechaFinPlanilla
  );
  if (!periodo?.fecha_cese) return null;
  const cese = extraerFechaYMD(periodo.fecha_cese);
  const inicio = extraerFechaYMD(fechaInicioPlanilla);
  const fin = extraerFechaYMD(fechaFinPlanilla);
  if (!cese || !inicio || !fin) return null;
  if (cese < inicio || cese > fin) return null;
  return periodo.fecha_cese;
}
